export default __webpack_public_path__ + "static/media/Ofak.4582a5f0.JPG";